import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const categories = [{
  id: 'alimentation',
  title: 'Alimentation',
  description: 'Produits frais, épicerie et conserves de première qualité.',
  image: 'https://images.unsplash.com/photo-1608686207856-001b95cf60ca?auto=format&fit=crop&q=80&w=600',
  href: '/alimentation'
}, {
  id: 'boisson',
  title: 'Boisson',
  description: 'Eaux, jus, sodas et boissons chaudes pour tous les goûts.',
  image: 'https://images.unsplash.com/photo-1556881286-fc6915169721?auto=format&fit=crop&q=80&w=600',
  href: '/boisson'
}, {
  id: 'maison',
  title: 'Maison et Décoration',
  description: "Articles ménagers, entretien et décoration d'intérieur.",
  image: 'https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&q=80&w=600',
  href: '/maison'
}, {
  id: 'electronique',
  title: 'Electronique',
  description: 'Appareils, accessoires et équipements high-tech.',
  image: 'https://images.unsplash.com/photo-1498049794561-7780e7231661?auto=format&fit=crop&q=80&w=600',
  href: '/electronique'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function Categories() {
  return <section id="categories" className="py-20 bg-gray-50" data-id="element-21">
      <div className="container mx-auto px-4 md:px-6 lg:px-8" data-id="element-22">
        <div className="text-center mb-16" data-id="element-23">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-navy mb-4" data-id="element-24">
            Nos Catégories
          </h2>
          <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-25"></div>
        </div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-26">
          {categories.map(category => <motion.div key={category.id} variants={itemVariants} data-id="element-27">
              <Link to={category.href} className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col h-full border border-gray-100" data-id="element-28">
                <div className="relative h-48 overflow-hidden" data-id="element-29">
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors z-10" data-id="element-30" />
                  <img src={category.image} alt={category.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" data-id="element-31" />
                </div>
                <div className="p-6 flex flex-col flex-grow" data-id="element-32">
                  <h3 className="text-xl font-heading font-bold text-brand-navy mb-2 group-hover:text-brand-green transition-colors" data-id="element-33">
                    {category.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4 flex-grow" data-id="element-34">
                    {category.description}
                  </p>
                  <div className="flex items-center text-brand-gold font-semibold text-sm mt-auto" data-id="element-35">
                    Explorer{' '}
                    <ArrowRight className="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform" data-id="element-36" />
                  </div>
                </div>
              </Link>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}